
import { mapMutations } from "vuex"

export const PaginatorMixin = {
  data: () => ({
    currentPageLayer: 'about_us_layer',
    changeRange: { pos: 50, min: 0, max: 100 },
    currentPage: 1,
    pages: 0,
    pageInfo: [],
    scaleValues: {
      'screen-max-width': 2260,
      'screen-min-width': 700,
      'font-extend': [
        {
          className: 'font_extendalble_1_5',
          min: 1.5,
          max: 15,
          factor: .95,
          'screen-max-width': 1390,
          'screen-min-width': 700,
        },
        {
          className: 'font_extendalble_2',
          min: 2,
          max: 15,
          factor: .85,
          'screen-max-width': 1250,
          'screen-min-width': 700,
        }
      ]
    },
    autoScrolling: false,
  }),
  mounted() {
    window.addEventListener('resize', this.checkpagenv, true)
    document.addEventListener('scroll', this.checkpage, true)
  },
  destroyed() {
    window.removeEventListener('resize', this.checkpagenv, true)
    document.removeEventListener('scroll', this.checkpage, true)
  },
  methods: {
    ...mapMutations(['setScale']),

    checkpage() {
      if(this.autoScrolling) return

      let el = document.querySelector(`.${this.currentPageLayer}`)
      if(!el) return

      let dist = []
      for(let i=1; i<=this.pages; i++) {
        el = document.querySelector(`.${this.currentPageLayer} .page_${i}`).getBoundingClientRect()
        if(el.y >= this.changeRange.min && el.y <= this.changeRange.max) { 
          // top distance
          let pos__ = el.y + 100
          dist.push({ page: i, pos: Math.abs(this.changeRange.pos - pos__) })

        } else if(el.y + el.height >= this.changeRange.min && el.y + el.height <= this.changeRange.max) {
          // bottom distance
          let pos__ = el.y + el.height - 100
          dist.push({ page: i, pos: Math.abs(this.changeRange.pos - pos__) })
        }
      }

      if(dist.length === 0) return
      if(dist.length === 1) var target = dist[0].page
      else {
        if(dist[0].pos < dist[1].pos) target = dist[0].page
        else target = dist[1].page
      }

      if(this.currentPage === target) return
      this.currentPage = target
      this.$refs['paginator'].setPage(this.pages, this.currentPage)
    },
    checkpagenv() {
      let w = window.outerWidth
      let h = window.outerHeight
      
      // 1. set the value of the boundary lines for the chagning page
      this.changeRange.pos = parseInt(h * .5)
      this.changeRange.min = parseInt(h * .4)
      this.changeRange.max = parseInt(h * .6)
      
      // 2. set the scale of the page contents
      let width__ = w
      let scale__ = 1

      if(w >= this.scaleValues['screen-min-width'] && w < this.scaleValues['screen-max-width']) {
        scale__ = (w / this.scaleValues['screen-max-width']).toFixed(2)
        width__ += parseInt(this.scaleValues['screen-max-width'] * (1 - scale__))

      } else if(w < this.scaleValues['screen-min-width']) {
        scale__ = (this.scaleValues['screen-min-width'] / this.scaleValues['screen-max-width']).toFixed(2)
        width__ += parseInt(this.scaleValues['screen-max-width'] * (1 - scale__))
        width__ -= (this.scaleValues['screen-min-width'] - w) * 2.3
      }

      // set font scale
      this.scaleValues['font-extend'].forEach(f => {
        let els = document.querySelectorAll(`.${this.currentPageLayer} .${f.className}`)
        if(!els || els.length === 0) return
        
        let scale____ = 1
        if(w >= f['screen-min-width'] && w < f['screen-max-width']) scale____ = (w / f['screen-max-width']).toFixed(2)
        else if(w < f['screen-min-width']) scale____ = (f['screen-min-width'] / f['screen-max-width']).toFixed(2)

        if(scale____ != 1) {
          scale____ /= f.factor
          if(f.min / scale____ < f.min) scale____ = 1
        }
  
        els.forEach(el => { el.style.fontSize = `${(f.min / scale____).toFixed(2)}rem` })
      })

      // set page scale
      for(let i=1; i<=this.pages; i++) {
        let el = document.querySelector(`.${this.currentPageLayer} .page_${i} .contents_wrapper`)
        if(!el) return

        el.style.transform = `scale(${scale__})`
        el.style.minWidth = `${width__}px`
      }

      // set store value 'scale'
      this.setScale(scale__)

      // 3. set page align by the page's contents wrapper
      for(let i=1; i<=this.pages; i++) {
        let el = document.querySelector(`.${this.currentPageLayer} .page_${i} .contents_wrapper`)
        if(!el) return

        let elpage = document.querySelector(`.${this.currentPageLayer} .page_${i}`)
        let elbox = el.getBoundingClientRect()

        if(elbox.height <= h && elpage.classList.contains('align_start')) {
          elpage.classList.remove('align_start')
          elpage.classList.add('align_center')
          elpage.style.height = '100%'

        } else if(elbox.height > h) {
          if(elpage.classList.contains('align_center')) {
            elpage.classList.remove('align_center')
            elpage.classList.add('align_start')
          }
          elpage.style.height = `${elbox.height}px`
        }
      }

      this.setPageInfo()
    },
    scrollPage(page) {
      if(this.currentPage == page) return

      this.autoScrolling = true
      this.currentPage = page

      window.scrollTo({
        top: this.pageInfo[`page_${page}`].y,
        behavior: 'smooth',
      })

      this.isScrollDone(page)
    },
    isScrollDone(page, timeout=1000) {
      setTimeout(() => { 
        // let el = document.querySelector(`.${this.currentPageLayer} .page_${page}`)
        // if(!el) {
        //   this.autoScrolling = false
        //   return
        // }

        this.autoScrolling = false
      }, timeout)
    },
    setPaginator() {
      let el = document.querySelectorAll(`.${this.currentPageLayer} div[class*=page_]`)
      if(!el) return

      if(el.length === 0) {
        this.currentPage = 1
        this.pages = 0
        this.$refs['paginator'].setPage(0, 1)
      } else {
        this.pages = el.length
        this.currentPage = 1
        if(this.$refs['paginator']) this.$refs['paginator'].setPage(this.pages, this.currentPage)
      }
    },
    setPageInfo() {
      let el = document.querySelectorAll(`.${this.currentPageLayer} div[class*=page_]`)
      if(!el) return

      let pageInfo__ = {}
      let nextY__ = 0

      el.forEach((element, i) => {
        let box = element.getBoundingClientRect()
        pageInfo__[`page_${i+1}`] = { y: nextY__ }

        nextY__ += box.height
      })

      this.pageInfo = pageInfo__
    },
    setEnv() {
      this.setPaginator() 
      this.checkpagenv()
    }
  }
}